import { CardActionArea } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';

type MediaCardProps = {
  imgSrc: string,
  title: string,
  subtitle: string,
  isDarkMode?: boolean,
  mediaHeight: number,
}

export default function MediaCard(props: MediaCardProps) {
  return (
    <Card>
      <CardActionArea>
        <CardMedia
          component="img"
          height={props.mediaHeight}
          image={props.imgSrc}
          alt="green iguana"
          sx={{objectFit: "covert"}}
        />
        <CardContent sx={{
          backgroundColor: props.isDarkMode ? "gray" : "auto",
          color: props.isDarkMode ? "white" : "auto",
        }}>
          <Typography gutterBottom variant="h6" component="div">
            {props.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.subtitle}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
